module.exports = __webpack_public_path__ + "img/astronomy.6d74bec3.svg";